<template>
  <div id="app">
    <div class="main-container" v-if="!verifyingToken && !isAuthenticated">
      <AuthGate :initial-notice="sessionExpiredNotice" @authenticated="onAuthenticated" />
    </div>

    <div class="main-container" v-if="!verifyingToken && isAuthenticated">
      <CandidatePortal :user-email="currentUser.email" @logout="logout" @email-changed="onEmailChanged" />
    </div>

    <div class="main-container" v-if="verifyingToken">
      <div class="text-center" v-if="loading">
        <div class="spinner-border" role="status">
          <span class="sr-only">Cargando...</span>
        </div>
      </div>

      <div class="container" v-if="showModal">
        <div class="card-content">
          <div class="content">
            <h1 class="is-5 centered">
              {{ alert.title }}
            </h1>
            <p class="detail centered">
              {{ alert.detail }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CandidatePortal from "./components/portal/CandidatePortal.vue";
import AuthGate from "./components/auth/AuthGate.vue";
import * as authApi from "./services/authApi";

// import axios from 'axios';

export default {
  name: "app",
  components: {
    CandidatePortal,
    AuthGate,
  },
  data() {
    return {
      verifyingToken: true,
      loading: true,
      showModal: false,
      alert: {
        title: "",
        detail: "",
      },
      isAuthenticated: false,
      currentUser: null,
      sessionExpiredNotice: "",
    };
  },
  mounted() {
    if (authApi.consumeSessionExpiredFlag()) {
      this.sessionExpiredNotice = "Su sesión expiró por inactividad. Inicie sesión de nuevo.";
    }

    const session = authApi.getSession();
    if (session) {
      this.isAuthenticated = true;
      this.currentUser = session.user;
    }

    const token = this.$route.query.token;
    if (!token) {
      this.verifyingToken = false;
    } else {
      this.verifyingToken = true;
      // this.validateToken(token)
    }
  },
  methods: {
    // New accounts and returning ones alike land on the portal, which fills the application section by section.
    onAuthenticated(data) {
      authApi.saveSession(data);
      this.currentUser = data.user;
      this.isAuthenticated = true;
    },
    // The candidate changed the account's email in "Datos personales": the session (and the portal's header) follow it.
    onEmailChanged(email) {
      const session = authApi.getSession();
      this.currentUser = { ...this.currentUser, email };
      if (session) authApi.saveSession({ ...session, user: this.currentUser });
    },
    logout() {
      authApi.clearSession();
      this.isAuthenticated = false;
      this.currentUser = null;
    },
    /* validateToken(token) {
      this.loading = true;
      axios.get(`${process.env.VUE_APP_SERVER_ENDPOINT}/invoice/validate/${token}`)
        .then(() => {
          this.alert = {
            title: 'Correo validado exitosamente',
            detail: 'El correo ha sido validado exitosamente',
          }
          this.showModal = true;
        })
        .catch(err => {
          const code = err.response.status
          if (code === 403) {
            this.alert = {
              title: 'Correo ya ha sido validado',
              detail: 'El correo ya ha sido validado'
            }
          } else {
            this.alert = {
              title: 'Ha ocurrido un error',
              detail: err.response.data
            }
          }
          this.showModal = true;
        }).finally(() => {
          this.loading = false;
        })
        },*/
  },
};
</script>

<style scoped>
.hr {
  background-color: #e6ce9e;
  margin: 0;
  height: 5px;
}
.centered {
  margin-top: 20px;
  text-align: center;
}
</style>
